import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 8,
  class: "geo-payment-methods__actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_FallbackImage = _resolveComponent("FallbackImage")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_AddSecretKeySidebar = _resolveComponent("AddSecretKeySidebar")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      size: "small",
      class: "global-payment-methods",
      data: _ctx.globalPaymentMethodList,
      "row-key": "billingPaymentMethodId",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          label: "#",
          align: "center"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.globalPaymentMethodColumnsList, (column) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: column.value,
            prop: column.value,
            label: column.label,
            align: column.align,
            width: column.width
          }, {
            default: _withCtx(({ row }) => [
              (column.value === _ctx.GlobalPaymentMethodColumnProperties.IMAGE_URL)
                ? (_openBlock(), _createBlock(_component_FallbackImage, {
                    key: 0,
                    "model-value": row,
                    class: "global-payment-methods__logo"
                  }, null, 8 /* PROPS */, ["model-value"]))
                : _createCommentVNode("v-if", true),
              (column.value === _ctx.GlobalPaymentMethodColumnProperties.SEGMENT_LIST)
                ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                    key: 1,
                    "max-height": "70",
                    always: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.segmentList, (segment) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: segment.segmentId
                        }, _toDisplayString(segment.name), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */))
                : _createCommentVNode("v-if", true),
              (column.value === _ctx.GlobalPaymentMethodColumnProperties.EXCLUDED_SEGMENT_LIST)
                ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                    key: 2,
                    "max-height": "70",
                    always: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.excludedSegmentList, (segment) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: segment.segmentId
                        }, _toDisplayString(segment.name), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */))
                : _createCommentVNode("v-if", true),
              (column.value === _ctx.GlobalPaymentMethodColumnProperties.PAYMENT_TYPE_NAME)
                ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                    key: 3,
                    "max-height": "70",
                    always: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.paymentTypes, (paymentType) => {
                        return (_openBlock(), _createElementBlock("div", { key: paymentType }, _toDisplayString(_ctx.getPaymentTypeLabel(paymentType)), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */))
                : _createCommentVNode("v-if", true),
              (column.value === _ctx.GlobalPaymentMethodColumnProperties.DEPOSIT_LIMIT_LIST ||
            column.value === _ctx.GlobalPaymentMethodColumnProperties.WITHDRAW_LIMIT_LIST)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(row[column.value], ({ currency, min, max, extendedLimits }) => {
                    return (_openBlock(), _createElementBlock("div", { key: currency }, [
                      _createTextVNode(_toDisplayString(currency) + " - " + _toDisplayString(min) + " → " + _toDisplayString(max) + " ", 1 /* TEXT */),
                      extendedLimits
                        ? (_openBlock(), _createElementBlock("b", _hoisted_1, "(" + _toDisplayString(extendedLimits) + " excp.)", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (column.value === _ctx.GlobalPaymentMethodColumnProperties.CURRENCY_CONVERTER_LIST)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 5 }, _renderList(_ctx.formatCurrencyConverter(row), (converter) => {
                    return (_openBlock(), _createElementBlock("div", { key: converter }, _toDisplayString(converter), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              ((column.value === _ctx.GlobalPaymentMethodColumnProperties.DEPOSIT_ENABLED ||
            column.value === _ctx.GlobalPaymentMethodColumnProperties.WITHDRAW_ENABLED) && row.vaultEnabled)
                ? (_openBlock(), _createBlock(_component_el_switch, {
                    key: 6,
                    modelValue: row[column.value],
                    "onUpdate:modelValue": ($event: any) => ((row[column.value]) = $event),
                    disabled: !_ctx.isPartialUpdateGlobalPaymentMethodAllowed,
                    onChange: ($event: any) => (_ctx.switchPaymentMethod(row, column.value))
                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]))
                : _createCommentVNode("v-if", true),
              ((column.value === _ctx.GlobalPaymentMethodColumnProperties.DEPOSIT_ENABLED ||
            column.value === _ctx.GlobalPaymentMethodColumnProperties.WITHDRAW_ENABLED) && !row.vaultEnabled)
                ? (_openBlock(), _createBlock(_component_el_popover, {
                    key: 7,
                    "popper-class": "ps-limits-details__limits-popover",
                    width: 400,
                    trigger: "hover"
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        text: "",
                        type: "danger",
                        icon: _ctx.icons.QuestionFilled
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode(" Unavailable ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["icon"])
                    ]),
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createElementVNode("p", null, " Secret key is required to enable this payment system. Please, contact developer. ", -1 /* CACHED */))
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (column.value === _ctx.GlobalPaymentMethodColumnProperties.ACTIONS)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_el_dropdown, {
                      trigger: "click",
                      onCommand: ($event: any) => (_ctx.getDropdownActionCommand($event, row))
                    }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, {
                              disabled: !_ctx.isUpdateGlobalPaymentMethodAllowed,
                              command: {
                      action: _ctx.GlobalDropdownActionCommand.OPEN_EDIT_PAYMENT_METHOD,
                    }
                            }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode(" Global settings ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "command"]),
                            _createVNode(_component_el_dropdown_item, {
                              disabled: !_ctx.isUpdateExceptionLimitAllowed,
                              command: {
                      action: _ctx.GlobalDropdownActionCommand.OPEN_EXCEPTION_LIMIT_SETTINGS,
                      operationType: _ctx.PaymentMethodExceptionLimitType.DEPOSIT,
                    }
                            }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode(" Global exception deposit limits ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "command"]),
                            _createVNode(_component_el_dropdown_item, {
                              disabled: !_ctx.isUpdateExceptionLimitAllowed,
                              command: {
                      action: _ctx.GlobalDropdownActionCommand.OPEN_EXCEPTION_LIMIT_SETTINGS,
                      operationType: _ctx.PaymentMethodExceptionLimitType.WITHDRAWAL,
                    }
                            }, {
                              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createTextVNode(" Global exception withdrawal limits ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "command"]),
                            (row.isCurrencyConversionAvailable)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 0,
                                  disabled: !_ctx.isUpdateConverterSettingsAllowed,
                                  command: {
                      action: _ctx.GlobalDropdownActionCommand.OPEN_INTERNAL_CONVERTER_SETTINGS,
                    }
                                }, {
                                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                    _createTextVNode(" Converter settings ", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled", "command"]))
                              : _createCommentVNode("v-if", true),
                            (typeof row.secretsAdded === 'boolean' && row.secretsFormat)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 1,
                                  command: {
                      action: _ctx.GlobalDropdownActionCommand.OPEN_ADD_SECRET_KEY,
                    }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.addSecretKeyLabel(row.secretsAdded)), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["command"]))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          icon: _ctx.icons.Setting,
                          circle: "",
                          size: "small"
                        }, null, 8 /* PROPS */, ["icon"])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onCommand"])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["prop", "label", "align", "width"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["data"])), [
      [_directive_loading, _ctx.isGlobalPaymentMethodListLoading]
    ]),
    (_ctx.visibleDrawer && _ctx.selectedPaymentMethod)
      ? (_openBlock(), _createBlock(_component_AddSecretKeySidebar, {
          key: 0,
          modelValue: _ctx.visibleDrawer,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visibleDrawer) = $event)),
          "payment-method": _ctx.selectedPaymentMethod
        }, null, 8 /* PROPS */, ["modelValue", "payment-method"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}